import { useFilterSchema } from 'hooks/useFilterSchema'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getAppliedFilters, Variables } from 'reducers/filtering/selectors'
import { RootState } from 'reducers/store'
import { selectSubGroupUserSubscription } from 'reducers/subscription/selectors'
import { CategoryGroupName } from 'typings/filters'
import { mapFiltersWithValues } from 'util/validateContext'

export const useAppliedBaseFilters = () => {
  const { filterSchema } = useFilterSchema()
  const subGroupFilters = useSelector((state: RootState) => selectSubGroupUserSubscription(state))
  const appliedFilters = useSelector((state: RootState) => getAppliedFilters(state))

  const appliedFiltersBase = useMemo(
    () => (appliedFilters ?? {})[CategoryGroupName.General_Base],
    [appliedFilters]
  )
  const subGroupFiltersBase = useMemo(() => subGroupFilters ?? [], [subGroupFilters])
  const countryAnswers = useSelector(
    (state: RootState) => state.filters.filterValues[Variables.COUNTRY.toString() + filterSchema]
  )

  const productGroupsAnswers = useSelector(
    (state: RootState) =>
      state.filters.filterValues[Variables.PRODUCT_GROUP.toString() + filterSchema]
  )

  const productFilters = useMemo(() => {
    return mapFiltersWithValues(appliedFiltersBase, Variables.PRODUCT_GROUP, productGroupsAnswers)
  }, [appliedFiltersBase, productGroupsAnswers])
  const countryFilters = useMemo(() => {
    return mapFiltersWithValues(appliedFiltersBase, Variables.COUNTRY, countryAnswers)
  }, [appliedFiltersBase, countryAnswers])
  return {
    appliedFiltersBase,
    subGroupFiltersBase,
    countryFilters,
    productGroupsAnswers,
    productFilters,
  }
}
